import angular from 'angular';
import uiRouter from 'angular-ui-router';
import {PageHeaderComponent} from './pageHeader.component.js';

const pageHeader = angular.module('pageHeader', []);
pageHeader.component('pageHeader', PageHeaderComponent);

export {pageHeader};



// WEBPACK FOOTER //
// ./app/components/common/pageHeader/pageHeader.js